/**
 * Kleine bouwstenen voor blokken die zelf hun gegevens laden: de tijd van
 * de laatste stand en laden of fout met Opnieuw. Kwam uit de map van motor
 * 6.1 (sessie 105); verhuisd naar gedeeld in sessie 8D, werking gelijk.
 * De klassen (`m61-...`) staan in `gedeeld.css`.
 */
import { foutTekst } from "./fout";
import { bijgewerkt } from "./opmaak";

export function Bijgewerkt({ moment }: { moment: string | null | undefined }) {
  if (!moment) return null;
  return <span className="m61-bijgewerkt num">{bijgewerkt(moment)}</span>;
}

/** Laden of een fout van een blok, met Opnieuw. */
export function LaadStand({
  laadt,
  fout,
  watFout,
  opnieuw,
}: {
  laadt: boolean;
  fout: unknown;
  watFout: string;
  opnieuw: () => void;
}) {
  if (fout) {
    return (
      <div className="v6-fout m61-fout" role="alert">
        {foutTekst(fout, watFout)}{" "}
        <button type="button" className="v6-link" onClick={opnieuw}>
          Opnieuw
        </button>
      </div>
    );
  }
  if (laadt) return <p className="m61-leeg">Laden</p>;
  return null;
}
